import { gql } from "graphql-request";

const RIDE_CREDIT_MUTATION = gql`
  mutation RideCredit(
    $id: ID!
    $rideDate: String
    $rideTime: String
    $ridePosition: String
    $rideRow: String
    $rideSide: String
  ) {
    updateRideCredit(
      input: {
        where: { id: $id }
        data: {
          RideDate: $rideDate
          RideTime: $rideTime
          RidePosition: $ridePosition
          RideRow: $rideRow
          RideSide: $rideSide
        }
      }
    ) {
      rideCredit {
        id
        RideDate
        RideTime
        RidePosition
        RideRow
        RideSide
        Attraction {
          id
          Name
        }
      }
    }
  }
`;

export default RIDE_CREDIT_MUTATION;
